import React from 'react';
import { useInView } from 'react-intersection-observer';

const StatItem = ({ number, label }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div 
      ref={ref} 
      className={`stat-item ${inView ? 'animated' : ''}`}
      style={{
        opacity: 0,
        transform: 'translateY(20px)',
        transition: 'opacity 0.6s ease, transform 0.6s ease'
      }}
    >
      <span className="stat-number">{number}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
};

const About = () => {
  const statsData = [
    { number: '1+', label: 'Yıllık Deneyim' },
    { number: '2+', label: 'Başarılı Ürün' },
    { number: '%100', label: 'Müşteri Memnuniyeti' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="section-header">
            <h2>Hakkımızda</h2>
            <p>Kinfhertix hikayesi</p>
          </div>
          <p>Kinfhertix, oyun güvenlik sistemlerinin nasıl çalıştığını ve nasıl geliştirilebileceğini araştırmak amacıyla kurulmuştur. Başlangıçta bir merak olarak başlayan çalışmalarımız, sektördeki en güvenilir oyun geliştirme çözümleri sağlayıcısı olmaya dönüşmüştür.</p>
          <p>Uzman ekibimiz, anti-hile sistemleri, güvenlik bypass çözümleri ve koruma mekanizmalarını geliştirmek için yaratıcı yöntemler üzerine çalışmaktadır. Sadece bilinen çözümleri sunmakla kalmıyor, oyun deneyiminizi iyileştirecek benzersiz yaklaşımlar geliştiriyoruz.</p>
          <p>Sürekli araştırma ve geliştirme ile yeni güvenlik önlemlerine uyum sağlıyor, her zaman bir adım önde kalıyoruz. Müşteri memnuniyeti ve ürün kalitesi en büyük önceliğimizdir.</p>
          <div className="stats-container">
            {statsData.map((stat, index) => (
              <StatItem 
                key={index}
                number={stat.number}
                label={stat.label}
              />
            ))}
          </div>
        </div>
        <div className="about-image">
          <div className="image-container">
            <img src={require('../assets/6583c817-841f-4300-8148-b2c04de612b6.png')} alt="About" />
            <div className="tech-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 